"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showDiscountedPricingSelector = exports.growthSuiteAvailableTermsSelector = exports.growthSuiteDiscountSelector = exports.isLatamEsEligibleSelector = exports.isHsfsSeedEligibleSelector = exports.isHSFXEligibleSelector = exports.allEligibleDiscountsSelector = exports.getProductPromotionEligibilityMapSelector = exports.annualDiscountSelector = exports.isAnnualDiscountEligibleSelector = exports.allPromotionsSelector = exports.merchSpecficPromotionEligibilitySelector = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _underscore = require("underscore");

var _Promotions = require("self-service-api/constants/Promotions");

var _Terms = require("self-service-api/constants/Terms");

var _Editions = require("self-service-api/constants/Editions");

var _TermIds = require("self-service-api/constants/TermIds");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _reselect = require("reselect");

var _PricingSelectors = require("./PricingSelectors");

var merchSpecficPromotionEligibilitySelector = function merchSpecficPromotionEligibilitySelector(_ref, merchandiseId) {
  var promotions = _ref.promotions;
  var allPromotions = promotions.merchEligibleForDirectPromotions;
  return allPromotions ? allPromotions[merchandiseId] || {} : {};
};

exports.merchSpecficPromotionEligibilitySelector = merchSpecficPromotionEligibilitySelector;

var allPromotionsSelector = function allPromotionsSelector(_ref2) {
  var promotions = _ref2.promotions;
  return promotions;
};

exports.allPromotionsSelector = allPromotionsSelector;

var isAnnualDiscountEligibleSelector = function isAnnualDiscountEligibleSelector(state, merchandiseId) {
  var productPromotion = merchSpecficPromotionEligibilitySelector(state, merchandiseId);
  return !!(productPromotion.annualTermId && productPromotion.annualTermId === _TermIds.ANNUAL_20_PERCENT_DISCOUNT);
};

exports.isAnnualDiscountEligibleSelector = isAnnualDiscountEligibleSelector;

var annualDiscountSelector = function annualDiscountSelector(state, merchandiseId) {
  var productPromotion = merchSpecficPromotionEligibilitySelector(state, merchandiseId);
  var hasAnnualDiscount = !!(productPromotion.annualTermId && productPromotion.annualTermId === _TermIds.ANNUAL_20_PERCENT_DISCOUNT);
  return hasAnnualDiscount && productPromotion.annualDiscount;
};

exports.annualDiscountSelector = annualDiscountSelector;
var getProductPromotionEligibilityMapSelector = (0, _reselect.createSelector)(allPromotionsSelector, function (promotions) {
  return function (merchandiseId) {
    return merchSpecficPromotionEligibilitySelector({
      promotions: promotions
    }, merchandiseId);
  };
});
exports.getProductPromotionEligibilityMapSelector = getProductPromotionEligibilityMapSelector;
var merchEligibleForDirectPromotionsSelector = (0, _reselect.createSelector)(allPromotionsSelector, function (promotions) {
  return promotions.merchEligibleForDirectPromotions;
}); // returns an array of all promotions keys with a discount that can be applied

var allEligibleDiscountsSelector = (0, _reselect.createSelector)(merchEligibleForDirectPromotionsSelector, function (merchEligibleForDirectPromotions) {
  var allPromotions = Object.values(merchEligibleForDirectPromotions || {});
  return (0, _underscore.uniq)(allPromotions.map(function (promotion) {
    return promotion.eligiblePromotion;
  }).filter(function (promotion) {
    return !!promotion && !promotion.includes(_Promotions.promotionKeys.NO_PROMOTION);
  }));
});
exports.allEligibleDiscountsSelector = allEligibleDiscountsSelector;

var isHSFXEligibleSelector = function isHSFXEligibleSelector(state) {
  var allPromotions = allEligibleDiscountsSelector(state);
  return allPromotions.includes(_Promotions.promotionKeys.HSFS_SEED) || allPromotions.includes(_Promotions.promotionKeys.HSFS_SERIES_A) || allPromotions.includes(_Promotions.promotionKeys.HSFX_ENTREPRENEUR) || allPromotions.includes(_Promotions.promotionKeys.HSFX_BOOTSTRAP);
};

exports.isHSFXEligibleSelector = isHSFXEligibleSelector;

var isHsfsSeedEligibleSelector = function isHsfsSeedEligibleSelector(state) {
  var allPromotions = allEligibleDiscountsSelector(state);
  return allPromotions.includes(_Promotions.promotionKeys.HSFS_SEED);
};

exports.isHsfsSeedEligibleSelector = isHsfsSeedEligibleSelector;

var isLatamEsEligibleSelector = function isLatamEsEligibleSelector(state) {
  var allPromotions = allEligibleDiscountsSelector(state);
  return allPromotions.includes(_Promotions.promotionKeys.LATAM_ES);
};

exports.isLatamEsEligibleSelector = isLatamEsEligibleSelector;

var growthSuiteDiscountSelector = function growthSuiteDiscountSelector(state) {
  if (isHsfsSeedEligibleSelector(state)) return 90;
  if (isLatamEsEligibleSelector(state)) return 50;
  var allPromotions = allEligibleDiscountsSelector(state);
  var isHsfsSeriesA = allPromotions.includes(_Promotions.promotionKeys.HSFS_SERIES_A);
  if (isHsfsSeriesA) return 50;
  var isHsfxBootstrap = allPromotions.includes(_Promotions.promotionKeys.HSFX_BOOTSTRAP);
  if (isHsfxBootstrap) return 40;
  var isHsfxEntrepreneur = allPromotions.includes(_Promotions.promotionKeys.HSFX_ENTREPRENEUR);
  if (isHsfxEntrepreneur) return 30;
  return 25;
};

exports.growthSuiteDiscountSelector = growthSuiteDiscountSelector;

var growthSuiteAvailableTermsSelector = function growthSuiteAvailableTermsSelector(state) {
  var _noEdition, _availableTermsMap, _STARTER, _PROFESSIONAL, _ENTERPRISE, _noEdition2, _termIdMap;

  var isCovidPromoEligible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var getAvailableTermsForMerch = (0, _PricingSelectors.getEligibleTermIdsSelector)(state); // This map is only to determine which terms should be available.
  // We proxy the availableTerms for marketing products to see what terms are available for growth suite
  // The actual term ID values are irrelevant.

  var availableTermsMap = (_availableTermsMap = {}, (0, _defineProperty2.default)(_availableTermsMap, _Editions.STARTER, getAvailableTermsForMerch(_MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019)), (0, _defineProperty2.default)(_availableTermsMap, _Editions.PROFESSIONAL, getAvailableTermsForMerch(_MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL)), (0, _defineProperty2.default)(_availableTermsMap, _Editions.ENTERPRISE, getAvailableTermsForMerch(_MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE)), (0, _defineProperty2.default)(_availableTermsMap, "noEdition", (_noEdition = {}, (0, _defineProperty2.default)(_noEdition, _Terms.MONTHLY, true), (0, _defineProperty2.default)(_noEdition, _Terms.ANNUAL, true), _noEdition)), _availableTermsMap);
  var termIdMap = (_termIdMap = {}, (0, _defineProperty2.default)(_termIdMap, _Editions.STARTER, (_STARTER = {}, (0, _defineProperty2.default)(_STARTER, _Terms.MONTHLY, null), (0, _defineProperty2.default)(_STARTER, _Terms.ANNUAL, null), _STARTER)), (0, _defineProperty2.default)(_termIdMap, _Editions.PROFESSIONAL, (_PROFESSIONAL = {}, (0, _defineProperty2.default)(_PROFESSIONAL, _Terms.MONTHLY, null), (0, _defineProperty2.default)(_PROFESSIONAL, _Terms.ANNUAL, null), _PROFESSIONAL)), (0, _defineProperty2.default)(_termIdMap, _Editions.ENTERPRISE, (_ENTERPRISE = {}, (0, _defineProperty2.default)(_ENTERPRISE, _Terms.MONTHLY, null), (0, _defineProperty2.default)(_ENTERPRISE, _Terms.ANNUAL, null), _ENTERPRISE)), (0, _defineProperty2.default)(_termIdMap, "noEdition", (_noEdition2 = {}, (0, _defineProperty2.default)(_noEdition2, _Terms.MONTHLY, null), (0, _defineProperty2.default)(_noEdition2, _Terms.ANNUAL, null), _noEdition2)), _termIdMap);

  var setTermIdsIfAvailable = function setTermIdsIfAvailable(monthlyTermId, annualTermId) {
    Object.keys(availableTermsMap).forEach(function (edition) {
      if (availableTermsMap[edition][_Terms.MONTHLY]) {
        termIdMap[edition][_Terms.MONTHLY] = monthlyTermId;
      }

      if (availableTermsMap[edition][_Terms.ANNUAL]) {
        termIdMap[edition][_Terms.ANNUAL] = annualTermId;
      }
    });
  };

  if (isLatamEsEligibleSelector(state)) {
    setTermIdsIfAvailable(_TermIds.MONTHLY_50_PERCENT_DISCOUNT, _TermIds.ANNUAL_50_PERCENT_DISCOUNT);
  } else if (isHSFXEligibleSelector(state)) {
    var hsfxTermIds = getAvailableTermsForMerch(_MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019 // proxy marketing starter's terms for growth suite terms
    );
    setTermIdsIfAvailable(hsfxTermIds[_Terms.MONTHLY], hsfxTermIds[_Terms.ANNUAL]);
  } else {
    setTermIdsIfAvailable(_TermIds.MONTHLY_25_PERCENT_DISCOUNT, _TermIds.ANNUAL_25_PERCENT_DISCOUNT);
  } // Force Covid promo for GS Starter monthly
  // HSFS Seed is exempt bc their discount is higher


  if (isCovidPromoEligible && !isHsfsSeedEligibleSelector(state)) {
    termIdMap[_Editions.STARTER][_Terms.MONTHLY] = _TermIds.COVID_PROMO_MONTHLY_66_PERCENT_DISCOUNT;
    termIdMap[_Editions.STARTER][_Terms.ANNUAL] = null;
  }

  return termIdMap;
};

exports.growthSuiteAvailableTermsSelector = growthSuiteAvailableTermsSelector;

var showDiscountedPricingSelector = function showDiscountedPricingSelector(state, merchandiseId, term) {
  var productPromotion = merchSpecficPromotionEligibilitySelector(state, merchandiseId); // Temporary special case here to show the discounted pricing
  // The term is monthly by default here; however the discount is
  // only annual since you can only buy Pro annually

  if (productPromotion && productPromotion.eligiblePromotion === 'MARKETING_BASIC_TO_PRO') {
    return true;
  }

  return !!(productPromotion && (productPromotion.monthlyDiscount && term === _Terms.MONTHLY || productPromotion.annualDiscount && term === _Terms.ANNUAL));
};

exports.showDiscountedPricingSelector = showDiscountedPricingSelector;